import React from 'react';
import { IntellectualTemplate, IntellectualTemplateData } from '../../templates/IntellectualTemplate';

// Reliable placeholders
const PLACEHOLDERS = {
    avatar: 'https://picsum.photos/seed/philosopher/400/400',
    book1: 'https://picsum.photos/seed/book1/300/450',
    book2: 'https://picsum.photos/seed/book2/300/450',
    book3: 'https://picsum.photos/seed/book3/300/450',
    book4: 'https://picsum.photos/seed/book4/300/450',
};

// Sample data for a philosophical thought leader
const sampleIntellectualData: IntellectualTemplateData = {
    identity: {
        name: 'Marcus Aurelius Sterling',
        avatar: PLACEHOLDERS.avatar,
        tagline: 'Philosopher. Writer. Seeker of Truth.',
        bio: 'I write about the intersection of technology, philosophy, and human flourishing. Former professor of philosophy at Oxford. Now exploring how ancient wisdom can guide us through the digital age.',
    },

    pinnedQuote: {
        text: 'The impediment to action advances action. What stands in the way becomes the way.',
        attribution: 'Marcus Aurelius, Meditations',
    },

    essays: [
        {
            id: '1',
            title: 'The Stoic\'s Guide to Crypto Volatility',
            excerpt: 'How ancient Roman philosophy can help you maintain equanimity during market chaos. The Stoics understood something fundamental about the nature of external events and our reactions to them.',
            category: 'Philosophy',
            date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
            readTime: '12 min read',
            link: '#',
        },
        {
            id: '2',
            title: 'Digital Sovereignty and the Examined Life',
            excerpt: 'Socrates urged us to examine our lives. In the age of algorithmic curation and attention harvesting, what does self-examination truly mean? A meditation on consciousness in the digital realm.',
            category: 'Technology',
            date: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),
            readTime: '18 min read',
            link: '#',
        },
        {
            id: '3',
            title: 'On the Nature of Trust in Trustless Systems',
            excerpt: 'Blockchain promises "trustlessness," yet trust permeates every layer of our engagement with it. What can Aristotle\'s virtue ethics teach us about building reliable institutions?',
            category: 'Ethics',
            date: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000),
            readTime: '15 min read',
            link: '#',
        },
        {
            id: '4',
            title: 'The Paradox of Choice in the Infinite Library',
            excerpt: 'Borges imagined a library containing every possible book. We now live in something approaching it. How do we find meaning when everything is available but nothing is necessary?',
            category: 'Culture',
            date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
            readTime: '14 min read',
            link: '#',
        },
    ],

    books: [
        {
            title: 'Meditations',
            author: 'Marcus Aurelius',
            cover: PLACEHOLDERS.book1,
            note: 'Read this every year. The foundational text.',
            link: '#',
        },
        {
            title: 'The Sovereign Individual',
            author: 'Davidson & Rees-Mogg',
            cover: PLACEHOLDERS.book2,
            note: 'Prophetic. More relevant now than when written.',
            link: '#',
        },
        {
            title: 'Finite and Infinite Games',
            author: 'James Carse',
            cover: PLACEHOLDERS.book3,
            note: 'Changed how I think about competition.',
            link: '#',
        },
        {
            title: 'The Beginning of Infinity',
            author: 'David Deutsch',
            cover: PLACEHOLDERS.book4,
            note: 'The most optimistic book ever written.',
            link: '#',
        },
    ],

    newsletter: {
        title: 'Letters on Human Flourishing',
        description: 'Weekly essays on philosophy, technology, and the good life. Join 28,000 readers on the examined path.',
        buttonText: 'Subscribe',
    },

    footerQuote: 'We are what we repeatedly do. Excellence, then, is not an act, but a habit.',

    social: {
        twitter: 'https://twitter.com/marcus_sterling',
        substack: 'https://sterling.substack.com',
        linkedin: 'https://linkedin.com/in/marcussterling',
    },
};

const IntellectualDemo: React.FC = () => {
    return <IntellectualTemplate data={sampleIntellectualData} />;
};

export default IntellectualDemo;
